import { color } from '../utils'
import { connect } from 'react-redux'
import { Grid, Content } from '../components/Layout'
import Box from '../components/Box'
import React, { Component } from 'react'
import styled from 'styled-components'
import { ReloadButton } from '../components/Form'
import { Redirect } from "react-router";

const ContentNotFound = styled(Content)`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  text-align: left;

  a {
    color: ${color.secondary};
  }

  h2,
  h5 {
    padding: 0;
    margin: 0.3em 0;
  }

  h5 {
    color: #999;
  }

  max-width: unset;
`

class LoginError extends Component {
  render() {
    const { accessToken } = this.props

    if (accessToken) {
      return <Redirect to='/' />
    }

    return (
      <Grid>
        <ContentNotFound>
          <Box>
            <h2>Ocorreu um erro</h2>
            <p>Houve um problema na autenticação, tente novamente mais tarde.</p>
            <p>
              Se o problema persistir, contate a equipe de suporte através do e-mail:{' '}
              <a href="mailto:ti@exo.com.br">ti@exo.com.br</a>
            </p>

            <ReloadButton
              onClick={() => {
                window.location.href = '/'
              }}
            />
          </Box>
        </ContentNotFound>
      </Grid>
    )
  }
}

const mapStateToProps = state => ({
  accessToken: state.headers.accessToken
})

const mapDispatchToProps = dispatch => ({})

export default connect(mapStateToProps, mapDispatchToProps)(LoginError)



// WEBPACK FOOTER //
// ./src/containers/LoginError.js